export default __webpack_public_path__ + "static/media/cfdLongImg.e33de640.webp";